// Retire l'attribut `src` de l'iframe avant que Turbo ne photographie la page
// pour son cache : sinon l'aperçu/la restauration recharge la démo aussitôt (puis
// une seconde fois quand lazy-iframe repose le src). Retirer l'attribut n'efface
// pas le document déjà chargé dans l'iframe vivante. Renvoie la fonction d'arrêt.
export function stripSrcBeforeTurboCache(frame, target = document) {
  const strip = () => frame.removeAttribute("src")
  target.addEventListener("turbo:before-cache", strip)
  return () => target.removeEventListener("turbo:before-cache", strip)
}
